import { Button } from "@/components/ui/button";

export default function IosAppButton() {
  return (
    <div className="border-white/10 border-t bg-light-black px-6 py-3.5">
      <Button asChild className="h-8.5 w-full rounded-[17px]" variant="cta">
        <a
          href="https://link.morty.app/VAdfzl1F9Ab"
          rel="noopener noreferrer"
          target="_blank"
        >
          Use the Morty iOS app
        </a>
      </Button>
    </div>
  );
}
